import { FC } from 'react';
import { Lock } from 'lucide-react';

export const LockedChip: FC = () => {
  return (
    <div className="w-23.25 flex items-center gap-1 px-3 py-1 bg-(--neutral-black-NB100) rounded-full">
      <Lock className="text-(--neutral-black-NB400)" size={12} />
      <span className="[&&]:[font-family:var(--font-montserrat)]! [font-size:var(--fs-l5)]! text-(--neutral-black-NB400)! ">
        Locked
      </span>
    </div>
  );
};
